import { httpClient } from '@/network/clientController'

/** Validate Phone Number to recover credentials
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_retrieveCredentialsvalidatePhone
*/
export const validatePhoneNumber = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'retrieveCredentials/validatePhone',
        data: payload
	})
}

/** Send Validate Phone Number OTP
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_retrieveCredentialsvalidatePhonevalidateOTP
*/
export const sendValidatePhoneNumberOTP = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'retrieveCredentials/validatePhone/validateOTP',
        data: payload
	})
}

/** Resend OTP to phoneNumber
@docs Não há documentação
*/
export const resendOTP = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'retrieveCredentials/challenge/reSend',
        data: payload
	})
}

/** Validate personal info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_retrieveCredentialsvalidatePersonalData
*/
export const validatePersonalData = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'retrieveCredentials/validatePersonalData',
        data: payload
	})
}

/** Retrieve Credentials
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_retrieveCredentials
*/
export const retrieveCredentials = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'retrieveCredentials',
        data: payload
	})
}

/** Retrieve Credentials Resend
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_retrieveCredentialsaccessionNumberreSend
*/
export const retrieveCredentialsResend = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'retrieveCredentials/accessionNumber/reSend',
        data: payload
	})
}

/** Retrieve Credentials Finish
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_retrieveCredentialsfinish
*/
export const retrieveCredentialsFinish = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'retrieveCredentials/finish',
        data: payload
	})
}

/** Retrieve Credentials Token Resend
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_retrieveCredentialstokenresend
*/
export const retrieveCredentialsTokenResend = (payload) => {
    return httpClient({
		method: 'POST',
		url: '/retrieveCredentials/token/resend',
        data: payload
	})
}
